export default __webpack_public_path__ + "static/media/checkmark-circle.f0aa181c.svg";